import React from "react";
import EmergencyPlansPreviewNav from "./EmergencyPlansPreviewNav";
import JobShiftEmergencyPlansDocument from "../../../JobShiftEmergencyDocuments/JobShiftEmergencyPlansDocument";
import styles from "../PreviewV3.module.css";
export default function EmergencyPlansPreviewLayout({ plans, sections = {}, context = {} }) {
  return (
    <div className={styles.PreviewWrap}>
      <EmergencyPlansPreviewNav plans={plans} />
      <main>
        <div className={styles.PreviewDoc} style={{ background: "transparent", border: "none", borderRadius: 0 }}>
          <JobShiftEmergencyPlansDocument
            plans={plans}
            sections={sections}
            context={{ ...context, previewMode: true }}
            embedded
            withNavigationAnchors
          />
        </div>
      </main>
    </div>
  );
}
